import { ScreenWaveLoader } from '@/shared'
import loadable from '@loadable/component'

export const AdminRootLazy = loadable(() => import('./AdminRoot'), {
  fallback: <ScreenWaveLoader />
})
